/**
 * Enum which defines the user roles.
 *
 */
export const USER_ROLES = {
    ROLE_ADMIN: 'admin',
    ROLE_USER: 'user',
    ROLE_TEAM_MEMBER: 'team_member',
    ROLE_CATERER: 'caterer',
    ROLE_SUPPLIER: 'supplier',
    ROLE_ATTENDEE: 'attendee',
    ROLE_MANAGER: 'manager',
    ROLE_EVENT_PLANNER: 'event_planner',
}